import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "src/features/Layout";
import Typography from "@material-ui/core/Typography";
import { Form } from "react-final-form";
import { setPage, setSearch } from "src/features/Utils/mutators";
import moment from "moment";

import Search from "./Search";
import ShowTotal from "./ShowTotal";
import Table from "./Table";
import Paging from "./Pagination";
import NotFound from "src/features/Components/NoResults";

import { fetchList } from "../ducks";

const initialValues = {
  search_name: "",
  barcode: "",
  start_date: null,
  end_date: null,
  page: 1,
  limit: 10,
  // store searched fields in order to handle paging
  searched: {
    search_name: "",
    barcode: "",
    start_date: null,
    end_date: null,
  },
};

function Index() {
  const dispatch = useDispatch();
  const fetching = useSelector((state) => state.medicine.fetching);
  const total = useSelector((state) => state.medicine.total);

  const handleFetchList = (values = initialValues) => {
    dispatch(fetchList(values));
  };

  useEffect(() => {
    handleFetchList();
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={({ searched, page, limit, ...values }, { mutators }) => {
        const alter_values = {
          ...values,
          start_date:
            values.start_date === null
              ? null
              : moment(values.start_date).format("YYYY-MM-DD"),
          end_date:
            values.end_date === null
              ? null
              : moment(values.end_date).format("YYYY-MM-DD"),
        };
        // values will be set in 'searched'
        mutators.setSearch(alter_values);
        // reset page when search
        mutators.setPage(1);
        handleFetchList({ ...alter_values, limit, page: 1 });
      }}
      mutators={{ setPage, setSearch }}
      subscription={{ submitting: true, values: true }}
    >
      {({ handleSubmit, values }) => {
        const handleFecthWithValues = () => {
          handleFetchList(values);
        };
        return (
          <Layout>
            <Typography variant="h5">Medicine Promotion</Typography>
            <form onSubmit={handleSubmit}>
              <Search />
            </form>
            <ShowTotal
              total={total}
              fetching={fetching}
              handleFetchList={handleFetchList}
            />
            <Table fetchList={handleFecthWithValues} />
            {!total && <NotFound />}
            <Paging total={total} onFetch={handleFetchList} />
          </Layout>
        );
      }}
    </Form>
  );
}

export default Index;
